import { render } from "./outletCategory.vue?vue&type=template&id=619a20a2&scoped=true"
import script from "./outletCategory.vue?vue&type=script&lang=js"
export * from "./outletCategory.vue?vue&type=script&lang=js"

import "./outletCategory.vue?vue&type=style&index=0&id=619a20a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619a20a2"]])

export default __exports__